import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useOutletContext } from "react-router-dom";

import {
  UpdateAlertData,
  UpdateDates,
  UpdateSortTypeFilter,
  UpdatereportsFilterData,
  handleloading,
} from "../../Store/Redux/Reducers/Dashboardreducers";
import {
  CatchMessage,
  FirstDateofCurrentmonth,
  HandleDeviceId,
  HandleMeterId,
  JSONtoformdata,
  KWHText,
  WattText,
  getHrMinFormat,
  tokenisValid,
} from "../../Shared/Methods";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import {
  ConsumptionHistoryTableService,
  DashboardData,
  EnergyConsumptionReportService,
  EnergyConsumptionTableService,
  FailureAnalysisService,
} from "../../Services/ApiServices";
import Loader from "../../SharedComponents/Loader/Loader";
import classes from "../HomeScreen/Dashboard.module.css";
import RadialBar from "../../Charts/RadialBar";
import Linechart from "../../Charts/Linechart";
import {
  DaywiseReportProps,
  EnergyConsumptionProps,
  HourwiseReportProps,
} from "./Homescreens";
import BarChart from "../../Charts/BarChart";
import energyimg from "../../Assests/Images/energy-consumption (1).png";
import PieCharts from "../../Charts/PieCharts";
import alerticon from "../../Assests/Icons/warning.png";
import ShowMoreText from "../../Components/CommonText/ShowMoreText";
import HistoryTable from "../../Components/Tables/Dashboard/HistoryTable";
import Newcommontable from "../../Components/Tables/NewCommonTable";
import ConsumptionTable from "../../Components/Tables/Dashboard/Consumptiontable";
import { CommonDatePicker } from "../../Components/CommonForms/CommonDatePicker";
import ScrollToSectionButton from "../../Components/ScrollToSpecificSection";
import Commontooltip from "../../Components/CommonTooltip/Commontooltip";

function Dashboard() {
  const checkValue = (value: number) => value === 0;

  const { loading, MeterID, Dates } = useSelector(
    (state: any) => state.Dashboard
  );
  const { LoginData } = useSelector((state: any) => state.Auth);
  const dispatch = useDispatch();
  // const [dashboardData, setDashboardData] = useState<any>();
  const [hourlyReportData, sethourlyReportData] = useState<
    HourwiseReportProps[]
  >([]);
  const [daywiseReportData, setdaywiseReportData] = useState<
    DaywiseReportProps[]
  >([]);
  const [energyConsumtionTableData, setEnergyConsumtionTableData] = useState<
    EnergyConsumptionProps[]
  >([]);
  const [consumptonHistory, setConsumptonHistory] = useState<any>([]);
  const [highlight, sethighlight] = useState({
    ishighlight: false,
  });
  const CurrentDate: any = FirstDateofCurrentmonth();
  const outletcontext: any = useOutletContext();
  const {
    dashboardData,
    handleDashboardData,
    TotalDuration,
    pinnamelist,
    chartLabelData,
  } = outletcontext;
  const PinList = dashboardData?.pin_list || [];
  const chartdata = chartLabelData?.pin_list || [];
  const pinnamelistdata = [...pinnamelist, "Ideal Duration"];
  const ref = useRef();

  const { setFieldValue, values, setValues } = useFormik({
    initialValues: {
      hourlyfrom: new Date(),
      hourlyend: null,
      Consumptiondaywisefrom: CurrentDate,
      Consumptiondaywiseend: null,
      peekloaddaywisefrom: CurrentDate,
      peekloaddaywiseend: null,
    },
    onSubmit: () => {},
  });
  const navigate = useNavigate();
  // const [TotalDuration, setTotalDuration] = useState<any>();
  const [FailureAnalysis, setFailureAnalysis] = useState<any>();
  const renderondeviceID = HandleDeviceId();
  const renderonmeterID = HandleMeterId();
  const totaldata = TotalDuration?.every(checkValue) ? true : false;

  useEffect(() => {
    if (
      LoginData !== null &&
      renderondeviceID?.deviceId &&
      renderonmeterID?.meter_id
    ) {
      // setValues({
      //   ...values,
      // Consumptiondaywisefrom: values?.Consumptiondaywisefrom
      //   ? values?.Consumptiondaywisefrom
      //   : CurrentDate,
      // peekloaddaywisefrom: values?.peekloaddaywisefrom
      //   ? values?.peekloaddaywisefrom
      //   : CurrentDate,
      // });
      const ChartDate = {
        fromDatetime: values.Consumptiondaywisefrom
          ? dayjs(values.Consumptiondaywisefrom).format("YYYY-MM-DD 23:59")
          : "",
        toDatetime: values.Consumptiondaywiseend
          ? dayjs(values.Consumptiondaywiseend).format("YYYY-MM-DD 23:59")
          : "",
      };

      handleDashboardData(renderondeviceID, renderonmeterID);
      HandleFailureAnalysis();
      getEnergyConsumptionReport();
      getEnergyConsumptionReport("1", ChartDate);
      getEnergyConsumptionTable(1, 5);
      getConsumptionHistoryTable(1, 5);
      // dispatch(
      //   UpdateDates({
      //     fromDatetime: new Date(),
      //     toDatetime: null,
      //   })
      // );
    }
  }, [LoginData, renderondeviceID?.deviceId, renderonmeterID?.meter_id]);

  //EnergyComcumption Chart Date Api call
  useEffect(() => {
    if (
      LoginData?.token &&
      (values.Consumptiondaywisefrom || values.Consumptiondaywiseend)
    ) {
      const ChartDate = {
        fromDatetime: values.Consumptiondaywisefrom
          ? dayjs(values.Consumptiondaywisefrom).format("YYYY-MM-DD 23:59")
          : "",
        toDatetime: values.Consumptiondaywiseend
          ? dayjs(values.Consumptiondaywiseend).format("YYYY-MM-DD 00:00")
          : "",
      };
      getEnergyConsumptionReport("1", ChartDate);
    }
  }, [
    values.Consumptiondaywisefrom,
    values.Consumptiondaywiseend,
    // LoginData,
    values.peekloaddaywisefrom,
    values.peekloaddaywiseend,
  ]);

  //Peek Load Chart Date Api call
  // useEffect(() => {
  //   if (
  //     LoginData?.token &&
  //     (values.peekloaddaywisefrom || values.peekloaddaywiseend)
  //   ) {
  //     const ChartDate = {
  //       fromDatetime: values.peekloaddaywisefrom
  //         ? dayjs(values.peekloaddaywisefrom).format("YYYY-MM-DD 00:00")
  //         : "",
  //       toDatetime: values.peekloaddaywiseend
  //         ? dayjs(values.peekloaddaywiseend).format("YYYY-MM-DD 00:00")
  //         : "",
  //     };

  //     getEnergyConsumptionReport("1", ChartDate);
  //   }
  // }, [values.peekloaddaywisefrom, values.peekloaddaywiseend, LoginData]);

  //one minute once api call
  useEffect(() => {
    if (
      LoginData !== null &&
      renderondeviceID?.deviceId &&
      renderonmeterID?.meter_id
    ) {
      const interval = setInterval(() => {
        handleDashboardData(renderondeviceID, renderonmeterID);
        getEnergyConsumptionReport();
        getEnergyConsumptionReport("1", {
          fromDatetime: Dates?.fromDatetime
            ? dayjs(Dates?.fromDatetime).format("YYYY-MM-DD 23:59")
            : null,
          toDatetime: Dates?.toDatetime
            ? dayjs(Dates?.toDatetime).format("YYYY-MM-DD 00:00")
            : null,
        });
        // setValues({
        //   ...values,
        //   Consumptiondaywisefrom: Dates?.fromDatetime,
        //   peekloaddaywisefrom: Dates?.toDatetime,
        // });
        getEnergyConsumptionTable(1, 5);
        getConsumptionHistoryTable(1, 5);
        HandleFailureAnalysis();
      }, 60000);
      return () => clearInterval(interval);
    }
  }, [LoginData, renderondeviceID?.deviceId, renderonmeterID?.meter_id, Dates]);

  useEffect(() => {
    if (highlight?.ishighlight) {
      const interval = setInterval(() => {
        sethighlight({ ishighlight: false });
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [highlight?.ishighlight]);

  // const handleDashboardData = () => {
  //   dispatch(handleloading(true));

  //   let finalObj = {
  //     token: LoginData?.token,
  //     ...renderondeviceID,
  //     ...renderonmeterID,
  //   };

  //   DashboardData(JSONtoformdata(finalObj))
  //     .then(async (res) => {
  //       if (res?.data?.status === 1) {
  //         // let total_minutes = Math.floor(240 / 60) + Math.floor(120 / 60);

  //         // const Minutes = Math.floor(
  //         //   (res?.data?.data?.ideal_time_energy || 0) / 60
  //         // );
  //         // const Hours = Math.floor(Minutes / 60);
  //         // const TotalMinutes = Minutes % 60;

  //         // setTotalDuration([
  //         //   Math.floor((res?.data?.data?.eb_duration || 0) / 60),
  //         //   Math.floor((res?.data?.data?.dg_duration || 0) / 60),
  //         //   Math.floor((res?.data?.data?.ideal_time_energy || 0) / 60),
  //         // ]);

  //         setTotalDuration([
  //           Math.floor((res?.data?.data?.pin_1_duration || 0) / 60),
  //           Math.floor((res?.data?.data?.pin_2_duration || 0) / 60),
  //           Math.floor((res?.data?.data?.pin_3_duration || 0) / 60),
  //           Math.floor((res?.data?.data?.ideal_duration || 0) / 60),
  //         ]);

  //         // setTotalDuration([
  //         //   Math.floor(240 / 60),
  //         //   Math.floor(120 / 60),
  //         //   // 1440 - total_minutes,
  //         // ]);

  //         setDashboardData(res?.data?.data);
  //         dispatch(UpdateAlertData(res?.data?.data));
  //         sessionStorage.setItem("AlertData", JSON.stringify(res.data.data));
  //       } else if (res?.data?.status === -1) {
  //         const istokenValid = await tokenisValid(LoginData?.token);
  //         if (istokenValid) {
  //           toast.error(res?.data?.msg);
  //         } else {
  //           dispatch(HandleSessionModal(true));
  //         }
  //       } else {
  //         toast.error(res.data.msg);
  //       }
  //     })
  //     .catch((err) => CatchMessage(err))
  //     .finally(() => {
  //       dispatch(handleloading(false));
  //     });
  // };

  const getEnergyConsumptionTable = (page: number, size: number) => {
    const data = {
      token: LoginData?.token,
      ...renderondeviceID,
      ...renderonmeterID,
    };

    EnergyConsumptionTableService(page, size, JSONtoformdata(data))
      .then((res) => {
        if (res?.data?.status) {
          setEnergyConsumtionTableData(res?.data?.data?.items || []);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      });
  };

  const getConsumptionHistoryTable = (page: number, size: number) => {
    const data = {
      token: LoginData?.token,
      // sortType: 1,
      ...renderondeviceID,
      ...renderonmeterID,
    };

    ConsumptionHistoryTableService(page, size, JSONtoformdata(data))
      .then((res) => {
        if (res?.data?.status) {
          setConsumptonHistory(res?.data?.data?.items || []);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      });
  };

  const getEnergyConsumptionReport = (type = "", Chartdates = {}) => {
    const dataHourly = {
      token: LoginData?.token,
      ...renderondeviceID,
      ...renderonmeterID,
      fromDatetime: values.hourlyfrom
        ? dayjs(values.hourlyfrom).format("YYYY-MM-DD 23:59")
        : "",
      toDatetime: values.hourlyend
        ? dayjs(values.hourlyend).format("YYYY-MM-DD 00:00")
        : "",
      isDay: "",
    };

    const dataDaywise = {
      token: LoginData?.token,
      ...renderondeviceID,
      ...renderonmeterID,
      ...Chartdates,
      isDay: type,
    };

    EnergyConsumptionReportService(
      JSONtoformdata(type ? dataDaywise : dataHourly)
    )
      .then((res) => {
        if (res?.data?.status) {
          if (type) {
            setdaywiseReportData(res?.data?.data || []);
            return;
          }
          sethourlyReportData(res?.data?.data || []);
        }
      })
      .catch((err) => CatchMessage(err));
  };

  const MoveToConsumptioReport = () => {
    navigate("/reports/consumptionreport");
  };

  const MoveToHistoryReport = () => {
    navigate("/reports/historyreport");
    dispatch(UpdateSortTypeFilter(1));
  };

  const HandleFailureAnalysis = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...renderondeviceID,
      ...renderonmeterID,
    };

    FailureAnalysisService(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status === 1) {
          setFailureAnalysis(res?.data);
        } else if (res?.data?.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <Loader isLoader={loading} />

      <div
      // className={classes.dashboard_main_container}
      >
        {/* <h3 className="heading_style">Dashboard</h3> */}
        <Row className="pb-3">
          <Col className="" xl={4} lg={5} xs={12} style={{ display: "grid" }}>
            <Row className="pb-3 pb-lg-2">
              <div className={`primarycard h-100 d-grid`}>
                <p className={`pb-3 ${classes.headerlabel}`}>Device Details</p>
                <div
                  style={{
                    alignItems: "baseline",
                  }}
                  className={`py-2`}
                >
                  {/* <div className="flex around wrap pb-3 align-items-baseline">
                    <div className={classes.deviceDetailsTextContainer}>
                      <p className="pb-3">Device Name</p>
                      <p>
                        {dashboardData?.device_name
                          ? dashboardData?.device_name
                          : "-"}
                      </p>
                    </div>
                    <div className={classes.deviceDetailsTextContainer}>
                      <p className="pb-2">Device Code</p>
                      <p>
                        {dashboardData?.device_code
                          ? dashboardData?.device_code
                          : "-"}
                      </p>
                    </div>
                  </div> */}
                  <div className="flex between wrap pb-2 align-items-baseline gap-3">
                    {PinList?.length > 0 ? (
                      PinList?.map((ele: any, ind: number) => {
                        return (
                          <div className={classes.deviceDetailsTextContainer}>
                            <Commontooltip
                              children={
                                <p className="pb-1 device_pinname">
                                  {ele?.pin_name || `Pin ${ind + 1}`}
                                </p>
                              }
                              msg={ele?.pin_name}
                            />

                            <p>
                              {dashboardData[
                                `pin_${ele?.pin_number}_status`
                              ] === 1
                                ? "ON"
                                : "OFF"}
                            </p>
                          </div>
                        );
                      })
                    ) : (
                      <>
                        <div className={classes.deviceDetailsTextContainer}>
                          <Commontooltip
                            children={
                              <p className="pb-1 device_pinname">Pin 1</p>
                            }
                            msg="Pin 1"
                          />

                          <p>
                            {dashboardData?.pin_1_status === 1 ? "ON" : "OFF"}
                          </p>
                        </div>
                        <div className={classes.deviceDetailsTextContainer}>
                          <Commontooltip
                            children={
                              <p className="pb-1 device_pinname">Pin 2</p>
                            }
                            msg="Pin 2"
                          />

                          <p>
                            {dashboardData?.pin_2_status === 1 ? "ON" : "OFF"}
                          </p>
                        </div>
                        <div className={classes.deviceDetailsTextContainer}>
                          <Commontooltip
                            children={
                              <p className="pb-1 device_pinname">Pin 3</p>
                            }
                            msg="Pin 3"
                          />

                          <p>
                            {dashboardData?.pin_3_status === 1 ? "ON" : "OFF"}
                          </p>
                        </div>
                      </>
                    )}
                    {/* <div className={classes.deviceDetailsTextContainer}>
                      <p className="pb-2">Pin 1</p>
                      <p>{dashboardData?.pin_1_status === 0 ? "OFF" : "ON"}</p>
                    </div>

                    <div className={classes.deviceDetailsTextContainer}>
                      <p className="pb-2">Pin 2</p>
                      <p>{dashboardData?.pin_2_status === 0 ? "OFF" : "ON"}</p>
                    </div>
                    <div className={classes.deviceDetailsTextContainer}>
                      <p className="pb-2">Pin 3</p>
                      <p>{dashboardData?.pin_3_status === 0 ? "OFF" : "ON"}</p>
                    </div> */}
                    <Commontooltip
                      children={
                        // dashboardData?.relay1_name ? (
                        <div className={classes.deviceDetailsTextContainer}>
                          <p className="pb-1 device_pinname">
                            {dashboardData?.relay1_name || "Relay One"}
                          </p>
                          <p>{dashboardData?.relay1 === 1 ? "ON" : "OFF"}</p>
                        </div>
                        // ) : null
                      }
                      msg={dashboardData?.relay1_name}
                    />

                    <Commontooltip
                      children={
                        // dashboardData?.relay2_name ? (
                        <div className={classes.deviceDetailsTextContainer}>
                          <p className="pb-1 device_pinname">
                            {dashboardData?.relay2_name || "Relay Two"}
                          </p>
                          <p>{dashboardData?.relay2 === 1 ? "ON" : "OFF"}</p>
                        </div>
                        // ) : null
                      }
                      msg={dashboardData?.relay2_name}
                    />
                  </div>
                </div>
              </div>
            </Row>

            <Row className="">
              <div
                // style={{
                //   alignSelf: "center",
                //   display: "flex",
                //   justifyContent: "space-evenly",
                //   flexWrap: "wrap",
                // }}
                className={`primarycard mb-lg-2 h-100  ${classes.deviceDetailsTextContainer}
                  
                  `}
              >
                <p className={classes.headerlabel}>
                  Last Communicated Date&ensp;
                </p>
                <p>
                  {"("}
                  {dashboardData?.last_communicated_time
                    ? dayjs(dashboardData?.last_communicated_time).format(
                        "DD-MM-YYYY hh:mm A"
                      )
                    : "-"}
                  {")"}
                </p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <p style={{ display: "flex", alignItems: "end", gap: "4px" }}>
                    {dashboardData?.power_fail ? (
                      <>
                        <span
                          style={{
                            margin: "2px 0",
                            fontSize: "15px",
                            fontWeight: "500",
                          }}
                        >
                          Power Fail
                        </span>
                        <img
                          src={alerticon}
                          style={{ height: 30 }}
                          className={`blinkAnime `}
                          alt="alerticon"
                        />
                      </>
                    ) : null}
                  </p>
                </div>
                <p
                  style={{
                    marginTop: "9px",
                    fontSize: "13px",
                    fontWeight: "500",
                  }}
                >
                  Device Data Not Received :{" "}
                  <strong style={{ fontSize: "16px" }}>
                    {FailureAnalysis?.fail_time
                      ? getHrMinFormat(FailureAnalysis?.fail_time)
                      : "-"}
                  </strong>
                </p>

                <p
                  style={{
                    marginTop: "9px",
                    fontSize: "13px",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    if (FailureAnalysis?.communication_fail) {
                      navigate("/reports/readingreport");
                      dispatch(
                        UpdatereportsFilterData({
                          communicationfail: 1,
                          currentdate: new Date(),
                        })
                      );
                    } else {
                      e.preventDefault();
                    }
                  }}
                >
                  Read Error Time :{" "}
                  <strong style={{ fontSize: "16px" }}>
                    {FailureAnalysis?.communication_fail
                      ? getHrMinFormat(FailureAnalysis?.communication_fail)
                      : "-"}
                  </strong>
                </p>
              </div>
            </Row>
          </Col>

          <Col xl={8} lg={7} className="">
            <div className=" h-100 d-block d-sm-grid">
              {/* <div
                  style={{
                    alignSelf: "center",
                    display: "flex",
                    justifyContent: "space-evenly", 
                    flexWrap: "wrap",
                  }}
                  className={`primarycard mb-3 mb-lg-2 ${classes.deviceDetailsTextContainer}
                  `}
                >
                  <p className={classes.headerlabel}>
                    Last Communicated Date &ensp;{"("}
                    {dashboardData?.last_communicated_time
                      ? dayjs(dashboardData?.last_communicated_time).format(
                          "DD-MM-YYYY hh:mm A"
                        )
                      : "-"}
                    {")"}
                  </p>
                  <div>
                    <p>
                      {dashboardData?.power_fail == 0 ? (
                        <>
                          <span className={`blinkAnime ${classes.power_fail}`}>
                            Power Fail
                          </span>
                        </>
                      ) : null}
                    </p>
                  </div>
                </div> */}
              <Row>
                <Col
                  className="pe-lg-2 ps-0 ps-lg-1 pe-xl-3 pb-3 pb-lg-0 pt-3 pt-lg-0"
                  lg={6}
                >
                  <div className={`primarycard h-100`}>
                    <p className={classes.headerlabel}>Today Consumption</p>
                    <div className={`${classes.radialbarContainer}`}>
                      <RadialBar
                        label="Today"
                        series={dashboardData?.today_cunsumption}
                        percentage={
                          (dashboardData?.today_cunsumption * 100) /
                          dashboardData?.avgConsumption
                        }
                        AvgConsumption={dashboardData?.avgConsumption}
                        style={classes.radialbarContainer}
                        sethighlight={sethighlight}
                      />
                    </div>
                  </div>
                </Col>
                <Col className="ps-0 pe-0 pb-3 pb-lg-0" lg={6}>
                  <div className={`primarycard h-100`}>
                    <p className={classes.headerlabel}>Power Running Hours</p>
                    <div
                      className={`${classes.radialbarContainer}`}
                      style={{ flexDirection: "column" }}
                    >
                      <PieCharts
                        series={TotalDuration || []}
                        // label={["Pin 1", "Pin 2", "Pin 3", "Ideal Time"]}
                        label={pinnamelistdata}
                        ref={ref}
                      />

                      {totaldata ? null : (
                        <div
                          className="w-100"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "7px 15px",
                            flexFlow: "wrap",
                          }}
                        >
                          {chartdata?.map((ele: any, ind: number) => {
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  gap: 5,
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (ref.current) {
                                    //@ts-ignore
                                    ref.current.chart.toggleDataPointSelection(
                                      ind
                                    );
                                  }
                                }}
                              >
                                <p
                                  style={{
                                    background:
                                      ele?.key_name === "pin_1_status"
                                        ? "#20A2A0"
                                        : ele?.key_name === "pin_2_status"
                                        ? "#ee2560"
                                        : ele?.key_name === "pin_3_status"
                                        ? "#0090FF"
                                        : ele?.key_name === "Ideal_time"
                                        ? "#5d5d5d"
                                        : "",

                                    width: 15,
                                    height: 15,
                                    borderRadius: 20,
                                    marginBottom: 1,
                                  }}
                                ></p>
                                <Commontooltip
                                  children={
                                    <p
                                      className="device_pinname"
                                      style={{ fontWeight: 100, fontSize: 13 }}
                                    >
                                      {ele.pin_name}
                                    </p>
                                  }
                                  msg={ele?.pin_name}
                                />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>

                    {/* <div
                        className={`${classes.radialbarContainer}`}
                        style={{ gap: "20px" }}
                      >
                       
                        <img
                          src={energyimg}
                          alt="energyimg"
                          style={{ maxWidth: 100 }}
                        />
                        <p style={{ fontSize: 26, fontWeight: 600 }}>
                          {dashboardData?.wh_received}
                        </p>
                      </div> */}
                  </div>
                </Col>
              </Row>

              {/* <img className="img-auto" src={alertIcon} /> */}
            </div>
          </Col>
        </Row>

        {/* RYB cards with total consumptiona and today consumption */}

        <Row
          className={classes.multiCardContainer}
          style={{ flexDirection: "row-reverse" }}
        >
          <Col lg={9} xl={9} className="p-0">
            <Row>
              <Col xl={4} lg={4} md={6} className="pb-2 pt-2">
                <div>
                  <div
                    // style={{
                    //   background: "#7fffd46b",
                    // }}
                    className={classes.cardContainer}
                  >
                    <p className="pb-2">
                      Total Watts :{" "}
                      <span>
                        {dashboardData?.watts_total}
                        {WattText}
                      </span>
                    </p>
                    <div>
                      <div>
                        <p className="bg-red">R</p>
                        <p>
                          {dashboardData?.watts_r_phase
                            ? dashboardData?.watts_r_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-yellow">Y</p>
                        <p>
                          {dashboardData?.watts_y_phase
                            ? dashboardData?.watts_y_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-blue">B</p>
                        <p>
                          {dashboardData?.watts_b_phase
                            ? dashboardData?.watts_b_phase
                            : "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={4} lg={4} md={6} className="pb-2 pt-2">
                <div>
                  <div
                    // style={{
                    //   background: "#ffe4c480",
                    // }}
                    className={classes.cardContainer}
                  >
                    <p className="pb-2">
                      Avg LN Volts : <span>{dashboardData?.v_ln_avg} (V)</span>
                    </p>
                    <div>
                      <div>
                        <p className="bg-red">R</p>
                        <p>
                          {dashboardData?.v_r_phase
                            ? dashboardData?.v_r_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-yellow">Y</p>
                        <p>
                          {dashboardData?.v_y_phase
                            ? dashboardData?.v_y_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-blue">B</p>
                        <p>
                          {dashboardData?.v_b_phase
                            ? dashboardData?.v_b_phase
                            : "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={4} lg={4} md={6} className="pb-2 pt-2">
                <div>
                  <div
                    // style={{
                    //   background: "#8a2be23d",
                    // }}
                    className={classes.cardContainer}
                  >
                    <p className="pb-2">
                      Avg LL Volts : <span>{dashboardData?.v_ll_avg} (V)</span>
                    </p>
                    <div>
                      <div>
                        <p className={`bg-red ${classes.avg_ll_volts}`}>RY</p>
                        <p>
                          {dashboardData?.v_br_phase
                            ? dashboardData?.v_br_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className={`bg-yellow ${classes.avg_ll_volts}`}>
                          YB
                        </p>
                        <p>
                          {dashboardData?.v_ry_phase
                            ? dashboardData?.v_ry_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className={`bg-blue ${classes.avg_ll_volts}`}>BR</p>
                        <p>
                          {dashboardData?.v_yb_phase
                            ? dashboardData?.v_yb_phase
                            : "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={4} lg={4} md={6} className="pb-2 pt-2">
                <div>
                  <div
                    // style={{
                    //   background: "#ed143d3b",
                    // }}
                    className={classes.cardContainer}
                  >
                    <p className="pb-2">
                      Total VA : <span>{dashboardData?.va_total}</span>
                    </p>
                    <div>
                      <div>
                        <p className="bg-red">R</p>
                        <p>
                          {dashboardData?.va_r_phase
                            ? dashboardData?.va_r_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-yellow">Y</p>
                        <p>
                          {dashboardData?.va_y_phase
                            ? dashboardData?.va_y_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-blue">B</p>
                        <p>
                          {dashboardData?.va_b_phase
                            ? dashboardData?.va_b_phase
                            : "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={4} lg={4} md={6} className="pb-2 pt-2">
                <div>
                  <div
                    // style={{
                    //   background: "#aad21e4f",
                    // }}
                    className={classes.cardContainer}
                  >
                    <p className="pb-2">
                      Avg Amps : <span>{dashboardData?.i_avg} (A)</span>
                    </p>
                    <div>
                      <div>
                        <p className="bg-red">R</p>
                        <p>
                          {dashboardData?.i_r_phase
                            ? dashboardData?.i_r_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-yellow">Y</p>
                        <p>
                          {dashboardData?.i_y_phase
                            ? dashboardData?.i_y_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-blue">B</p>
                        <p>
                          {dashboardData?.i_b_phase
                            ? dashboardData?.i_b_phase
                            : "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xl={4} lg={4} md={6} className="pb-2 pt-2">
                <div>
                  <div
                    // style={{
                    //   background: "#ed143d3b",
                    // }}
                    className={classes.cardContainer}
                  >
                    <p className="pb-2">
                      Avg PF : <span>{dashboardData?.PF_avg}</span>
                    </p>
                    <div>
                      <div>
                        <p className="bg-red">R</p>
                        <p>
                          {dashboardData?.PF_r_phase
                            ? dashboardData?.PF_r_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-yellow">Y</p>
                        <p>
                          {dashboardData?.PF_y_phase
                            ? dashboardData?.PF_y_phase
                            : "0"}
                        </p>
                      </div>
                      <div>
                        <p className="bg-blue">B</p>
                        <p>
                          {dashboardData?.PF_b_phase
                            ? dashboardData?.PF_b_phase
                            : "0"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>

          <Col lg={3} xl={3} className="pt-2 pb-2">
            <div
              className={`primarycard h-100 pb-2`}
              style={{ border: "5px solid #20a2a099" }}
            >
              <p className={classes.headerlabel}>Total Consumption</p>
              <div
                className={`${classes.radialbarContainer}`}
                style={{ gap: "20px", flexWrap: "wrap" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  {dashboardData?.wh_received ? (
                    <>
                      <img
                        src={energyimg}
                        alt="energyimg"
                        className={classes.total_comsumption_img}
                      />
                      <div
                        style={{
                          display: "flex",
                          gap: "2px",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "calc(2vh + 17px)",
                            fontWeight: 600,
                          }}
                        >
                          {dashboardData?.wh_received}
                        </p>
                        <p>{KWHText}</p>
                      </div>{" "}
                    </>
                  ) : (
                    <p style={{ color: "rgb(55 61 63)" }}>No Data Found</p>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="pb-3" id="section-id">
          <Col className="pb-3 pb-lg-0" lg={6}>
            <div className="h-100">
              <div
                className={`primarycard h-100 ${
                  highlight.ishighlight ? "myDIV" : ""
                }`}
                // style={
                //   highlight.ishighlight ? { background: highlight?.color } : {}
                // }
              >
                <div className={classes.pickerContainer}>
                  <p className={classes.headerlabel}>
                    Hourly Energy Consumption
                  </p>
                  {/* <div>
                    <DatePicker
                      placeholder="From Date"
                      showTime
                      onChange={(value) => {
                        setFieldValue("hourlyfrom", value);
                      }}
                      onOk={() => {}}
                      value={values.hourlyfrom}
                      style={{
                        marginRight: "10px",
                        maxWidth: "160px",
                      }}
                    />
                    <DatePicker
                      placeholder="To Date"
                      showTime
                      onChange={(value) => {
                        setFieldValue("hourlyend", value);
                      }}
                      style={{
                        maxWidth: "160px",
                      }}
                      onOk={() => {}}
                      value={values.hourlyend}
                    />
                  </div> */}
                </div>
                <BarChart
                  series={hourlyReportData || []}
                  // type="Hourly Total Energy Consumption"
                  key={"0"}
                  labels={hourlyReportData?.map((ele) =>
                    dayjs(ele?.hour).format("hh:mm A")
                  )}
                  SeriesKey="totalConsumption"
                  colour="#20A2A0"
                  YAxisText="kWh"
                  XAxisText="Hour"
                />
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="h-100">
              <div className="primarycard h-100">
                <div className={classes.pickerContainer}>
                  <p className={classes.headerlabel}>
                    Daywise Energy Consumption
                  </p>
                  <div className="d-flex align-items-baseline">
                    <CommonDatePicker
                      value={values.Consumptiondaywisefrom}
                      onChange={(value) => {
                        // setFieldValue(
                        //   "Consumptiondaywisefrom",
                        //   value ? value : ""
                        // );
                        setValues({
                          ...values,
                          Consumptiondaywisefrom: value ? value : "",
                          peekloaddaywisefrom: value ? value : "",
                        });
                        dispatch(
                          UpdateDates({
                            fromDatetime: value || null,
                            toDatetime: values?.Consumptiondaywiseend
                              ? values?.Consumptiondaywiseend
                              : values?.peekloaddaywiseend,
                          })
                        );
                      }}
                      style={{
                        marginRight: "10px",
                        maxWidth: "160px",
                      }}
                      labelname="From Date"
                      name="Consumptiondaywisefrom"
                      nolabel={true}
                      FromDate={values.Consumptiondaywisefrom}
                      ToDate={values.Consumptiondaywiseend}
                      DateType="from_date"
                    />
                    <CommonDatePicker
                      value={values.Consumptiondaywiseend}
                      onChange={(value) => {
                        // setFieldValue(
                        //   "Consumptiondaywiseend",
                        //   value ? value : ""
                        // );

                        setValues({
                          ...values,
                          Consumptiondaywiseend: value ? value : "",
                          peekloaddaywiseend: value ? value : "",
                        });
                        dispatch(
                          UpdateDates({
                            fromDatetime: values?.Consumptiondaywisefrom
                              ? values?.Consumptiondaywisefrom
                              : values?.peekloaddaywisefrom,
                            toDatetime: value || null,
                          })
                        );
                      }}
                      style={{
                        maxWidth: "160px",
                      }}
                      labelname="To Date"
                      name="Consumptiondaywiseend"
                      nolabel={true}
                      ToDate={values.Consumptiondaywiseend}
                      FromDate={values.Consumptiondaywisefrom}
                      DateType="to_date"
                    />
                  </div>
                </div>
                <Linechart
                  series={daywiseReportData || []}
                  // type="Daywise Total Energy Consumption"
                  key={"1"}
                  labels={daywiseReportData?.map((ele) =>
                    dayjs(ele.date).format("DD-MM-YYYY")
                  )}
                  SeriesKey="totalConsumption"
                  colour="#20A2A0"
                  YAxisText="kWh"
                  XAxisText="Day"
                />
              </div>
            </div>
          </Col>
        </Row>

        <Row className="pb-3">
          <Col lg={6} className="pb-3 pb-lg-0">
            <div className="h-100">
              <div
                // style={{
                //   height: "calc(100% - 170px)",
                // }}
                className="primarycard h-100"
              >
                <p className={`pb-1 ${classes.headerlabel}`}>
                  Consumption Report
                </p>

                <Newcommontable
                  style={{
                    overflow: "auto",
                    maxHeight: "200px",
                  }}
                  Children={
                    <ConsumptionTable
                      Data={energyConsumtionTableData}
                      OBJHead={[
                        "S.No",
                        "Date",
                        "Start Time",
                        "End Time",
                        `Reading${KWHText}`,
                        `Consumed${KWHText}`,
                        // "EB Power",
                        // "Generator",
                        // "Ideal Time",
                        "Eb",
                        "Sump",
                        "Borewell",
                      ]}
                    />
                  }
                />
                {energyConsumtionTableData?.length > 0 ? (
                  <ShowMoreText handleSuccess={MoveToConsumptioReport} />
                ) : null}
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="h-100">
              <div
                // style={{
                //   height: "calc(100% - 170px)",
                // }}
                className="primarycard h-100"
              >
                <p className={`pb-1 ${classes.headerlabel}`}>ON OFF History </p>

                <Newcommontable
                  style={{
                    overflow: "auto",
                    maxHeight: "200px",
                  }}
                  Children={
                    <HistoryTable
                      Data={consumptonHistory}
                      OBJHead={[
                        "Date",
                        "S.No",
                        "Type",
                        "On Time",
                        "Off Time",
                        "Duration",
                      ]}
                    />
                  }
                />
                {consumptonHistory?.length > 0 ? (
                  <ShowMoreText handleSuccess={MoveToHistoryReport} />
                ) : null}
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col className="pb-3 pb-lg-0" lg={6}>
            <div className="h-100">
              <div className="primarycard h-100">
                <div className={classes.pickerContainer}>
                  <p className={classes.headerlabel}>
                    Hourly Peek Load (Watts)
                  </p>
                  {/* <div>
                    <DatePicker
                      placeholder="From Date"
                      showTime
                      onChange={(value) => {
                        setFieldValue("hourlyfrom", value);
                      }}
                      onOk={() => {}}
                      value={values.hourlyfrom}
                      style={{
                        marginRight: "10px",
                        maxWidth: "160px",
                      }}
                    />
                    <DatePicker
                      placeholder="To Date"
                      showTime
                      onChange={(value) => {
                        setFieldValue("hourlyend", value);
                      }}
                      style={{
                        maxWidth: "160px",
                      }}
                      onOk={() => {}}
                      value={values.hourlyend}
                    />
                  </div> */}
                </div>
                <BarChart
                  series={hourlyReportData || []}
                  // type="Hourly Current Load (Watts)"
                  key={"0"}
                  labels={hourlyReportData?.map((ele) =>
                    dayjs(ele?.hour).format("hh:mm A")
                  )}
                  SeriesKey="units"
                  colour="#f8ca00"
                  YAxisText="Kilo Watt"
                  XAxisText="Hour"
                />
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="h-100">
              <div className="primarycard h-100">
                <div className={classes.pickerContainer}>
                  <p className={classes.headerlabel}>
                    Daywise Peek load (Watts)
                  </p>
                  <div className="d-flex align-items-baseline">
                    <CommonDatePicker
                      value={values.peekloaddaywisefrom}
                      onChange={(value) => {
                        // setFieldValue(
                        //   "peekloaddaywisefrom",
                        //   value ? value : ""
                        // );
                        setValues({
                          ...values,
                          peekloaddaywisefrom: value ? value : "",
                          Consumptiondaywisefrom: value ? value : "",
                        });
                        dispatch(
                          UpdateDates({
                            fromDatetime: value || null,
                            toDatetime: values?.peekloaddaywiseend
                              ? values?.peekloaddaywiseend
                              : values?.Consumptiondaywiseend,
                          })
                        );
                      }}
                      style={{
                        marginRight: "10px",
                        maxWidth: "160px",
                      }}
                      labelname="From Date"
                      name="peekloaddaywisefrom"
                      nolabel={true}
                      FromDate={values.peekloaddaywisefrom}
                      ToDate={values.peekloaddaywiseend}
                      DateType="from_date"
                    />

                    <CommonDatePicker
                      value={values.peekloaddaywiseend}
                      onChange={(value) => {
                        // setFieldValue("peekloaddaywiseend", value ? value : "");
                        setValues({
                          ...values,
                          peekloaddaywiseend: value ? value : "",
                          Consumptiondaywiseend: value ? value : "",
                        });
                        dispatch(
                          UpdateDates({
                            fromDatetime: values?.Consumptiondaywisefrom
                              ? values?.Consumptiondaywisefrom
                              : values?.peekloaddaywisefrom,
                            toDatetime: value || null,
                          })
                        );
                      }}
                      style={{
                        maxWidth: "160px",
                      }}
                      labelname="To Date"
                      name="peekloaddaywiseend"
                      nolabel={true}
                      FromDate={values.peekloaddaywisefrom}
                      ToDate={values.peekloaddaywiseend}
                      DateType="to_date"
                    />
                  </div>
                </div>
                <Linechart
                  series={daywiseReportData || []}
                  // type="Daywise Current load (Watts)"
                  key={"1"}
                  labels={daywiseReportData?.map((ele) =>
                    dayjs(ele.date).format("DD-MM-YYYY")
                  )}
                  SeriesKey="units"
                  colour="#f8ca00"
                  YAxisText="Kilo Watt"
                  XAxisText="Day"
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Dashboard;
